import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from "react-router-dom";
import { Row, Col, Nav, Form, Image, Button, Navbar, Dropdown, Container, ListGroup, InputGroup, NavDropdown, Modal } from 'react-bootstrap';
import './clients.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faFilter } from '@fortawesome/free-solid-svg-icons';
import { useToken } from './tokenContext';
import { variables, EnumobjClientStatus, validEmail } from '../Variables';
import image from '../assets/images/login_img.jpg';
import { UseAuthContext } from '../context/AuthContext';

export const Login = (props) => {

    const [userIP, setUserIP] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [emailMessage, setEmailMessage] = useState("");
    const [passwordMessage, setPasswordMessage] = useState("");
    const [verificationMessage, setVerificationMessage] = useState("");
    const [showOtpVerification, setShowOtpVerification] = useState(false);
    const [otpMessage, setOtpMessage] = useState("");
    const [invalidOtpErrorMessage, setInvalidOtpErrorMessage] = useState("");
    const [otp, setOtp] = useState("");
    const navigate = useNavigate();
    const token = useToken();
    const {
        authUser,
        setAuthUser,
        isLoggedIn,
        setIsLoggedIn
    } = UseAuthContext();


    const authenticateUser = async (e) => {
        e.target.setAttribute("disabled", true);
        document.querySelector("body").style.cursor = "progress";
        let email = document.getElementById("userEmail");
        let pass = document.getElementById("userPassword");
        let isFieldEmpty = false;

        let user = {
            UserName: "",
            UserEmail: email.value,
            UserPassword: pass.value,
            UserIp: userIP,
            UserCountry: "",
            UserCity: "",
            UserState: "",
            UserStreet: ""
        }
        let errorMessage = [];

        if (user.UserEmail == "") {
            email.classList.add("empty");
            isFieldEmpty = true;
            setEmailMessage("Enter your email");
        }
        else if (user.UserEmail != "" && validEmail.test(user.UserEmail) == false) {
            email.classList.add("empty");
            isFieldEmpty = true;
            setEmailMessage("Enter a valid email");
        }

        if (user.UserPassword == "") {
            pass.classList.add("empty");
            isFieldEmpty = true;
            setPasswordMessage("Enter your password");
        }

        if (isFieldEmpty == true) {
            document.getElementById("errorMessage").innerHTML = "";
            errorMessage.forEach(e => {
                document.getElementById("errorMessage").innerHTML += e;
            })
            e.target.removeAttribute("disabled");
            document.querySelector("body").style.cursor = "default";
            return;
        }

        setEmail(email.value);
        setPassword(pass.value);

        let url = variables.API_URL + `User/AuthenticateUser?`;


        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        axios.post(url, JSON.stringify(user), jsonconfig) // ASP.NET Core API endpoint with header
            .then(response => {
                if (response.data == "OTP email successfully sent! Please contact admin to get OTP to proceed.") {
                    setVerificationMessage(response.data);
                    setShowOtpVerification(true)
                }
                else {
                    document.getElementById("errorMessage").innerHTML = "<div class='red'>" + response.data + "</div>";
                }
                e.target.removeAttribute("disabled");
                document.querySelector("body").style.cursor = "default";
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const verifyOTP = async (e) => {
        e.target.setAttribute("disabled", true);
        document.querySelector("body").style.cursor = "progress";
        let otp = document.getElementById("otp");
        let loginEmail = email;
        let isFieldEmpty = false;

        if (otp.value == "") {
            otp.classList.add("empty");
            isFieldEmpty = true;
            setOtpMessage("Enter valid OTP");
        }

        if (isFieldEmpty == true) {
            e.target.removeAttribute("disabled");
            document.querySelector("body").style.cursor = "default";
            return;
        }

        let url = variables.API_URL + `User/VerifyOTP?email=${loginEmail}&otp=${otp.value}`;

        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        axios.post(url, {}, jsonconfig) // ASP.NET Core API endpoint with header
            .then(response => {
                if (response.data.tokenValue != undefined) {
                    window.localStorage.setItem("authorized_user", JSON.stringify(response.data));
                    setIsLoggedIn(true);
                    setAuthUser(response.data)
                }
                else {
                    setInvalidOtpErrorMessage(response.data);
                }
                e.target.removeAttribute("disabled");
                document.querySelector("body").style.cursor = "default";
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const resentOTP = async (e) => {
        e.target.setAttribute("disabled", true);
        document.querySelector("body").style.cursor = "progress";

        setOtpMessage("");
        document.getElementById("otp").classList.remove("empty");
        setOtp("");
        setInvalidOtpErrorMessage("");

        let loginEmail = email;

        let url = variables.API_URL + `User/ResendOTP?email=${loginEmail}`;

        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        axios.post(url, {}, jsonconfig) // ASP.NET Core API endpoint with header
            .then(response => {
                if (response.data == "OTP email successfully resent! Please contact admin to get OTP to proceed.") {
                    setVerificationMessage(response.data);
                }
                else {
                    setInvalidOtpErrorMessage(response.data);
                }
                e.target.removeAttribute("disabled");
                document.querySelector("body").style.cursor = "default";
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const resetErrorFieldStyle = (e) => {
        if (e.target.classList.contains("empty")) {
            e.target.classList.remove("empty");
        }

        if (e.target.id == "userEmail" && e.target.value != "") {
            setEmailMessage("");
            setEmail(e.target.value);
        }
        else if (e.target.id == "otp" && e.target.value != "") {
            setOtpMessage("");
            setOtp(e.target.value);
        }
        else if (e.target.id == "userPassword" && e.target.value != "") {
            setPasswordMessage("");
            setPassword(e.target.value);
        }
    }

    const getIp = async () => {
        const res = await axios.get("https://api.ipify.org/?format=json");
        setUserIP(res.data.ip);
    };

    useEffect(() => {
        //passing getData method to the lifecycle method
        getIp();
    }, []);

    return (
        <section className="vh-100">
            <div className="container-fluid h-custom">
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="col-md-9 col-lg-6 col-xl-5">
                        <img src={image}
                            className="img-fluid" alt="Sample image" />
                    </div>
                    <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
                        {
                            showOtpVerification == false ?
                                <>
                                    <h3 className="mb-4 pb-3">Hello! Welcome Back</h3>
                                    <div className="text-danger" id="errorMessage"></div>
                                    <div className="form-outline mb-4 position-relative">
                                        <input type="email" id="userEmail" className="form-control"
                                            placeholder="Enter a valid email address" value={email} onChange={resetErrorFieldStyle} />
                                        <small className="text-danger position-absolute fs-small">{emailMessage}</small>
                                    </div>

                                    <div className="form-outline mb-4 position-relative">
                                        <input type="password" id="userPassword" className="form-control"
                                            placeholder="Enter password" value={password} onChange={resetErrorFieldStyle} />
                                        <small className="text-danger position-absolute fs-small">{passwordMessage}</small>
                                    </div>
                                    <div className="text-center text-lg-start mt-4 pt-2">
                                        <button type="button" className="btn-site btn-login" onClick={authenticateUser} >Login</button>
                                    </div>
                                </>
                                :
                                <>
                                    <h3 className="mb-2">Verification</h3>
                                    <p>{verificationMessage}</p>
                                    <span className="text-danger">{invalidOtpErrorMessage}</span>
                                    <div className="form-outline mb-4 position-relative">
                                        <input type="text" id="otp" className="form-control"
                                            placeholder="Enter a OTP" value={otp} onChange={resetErrorFieldStyle} />
                                        <small className="text-danger position-absolute fs-small">{otpMessage}</small>
                                    </div>
                                    <div className="text-center text-lg-start mt-3">
                                        <button type="button" className="btn-site btn-login" onClick={verifyOTP} >Verify</button>
                                    </div>
                                    <p>Didn't receive the verification OTP? <button className="btn-resend" onClick={resentOTP}>Resend again</button></p>
                                </>
                        }
                    </div>
                </div>
            </div>
        </section>
    );
};

